export default __webpack_public_path__ + "static/media/keyvisual-baden-baden-gaggenau.6f4a6d8e.jpg";